"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.IconWrapper = exports.sizes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _transitions = require("../../utils/transitions");

var _theme = require("../../utils/theme");

var sizes = {
  normal: 18,
  xxsmall: 15,
  xsmall: 24,
  small: 30,
  medium: 36,
  large: 42,
  xlarge: 54,
  xxlarge: 60
};
exports.sizes = sizes;
var preloader = (0, _styledComponents.keyframes)(["0%{transform:rotate(0deg);}6.6%{transform:rotate(50deg);}16.6%{transform:rotate(300deg);}23.4%{transform:rotate(350deg);}33.4%{transform:rotate(600deg);}40%{transform:rotate(650deg);}50%{transform:rotate(900deg);}56.6%{transform:rotate(950deg);}66.6%{transform:rotate(1200deg);}73.4%{transform:rotate(1250deg);}83.4%{transform:rotate(1500deg);}90%{transform:rotate(1550deg);}100%{transform:rotate(1800deg);}"]);

var IconSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Icon__IconSvg",
  componentId: "sc-1rdsvm6-0"
})(["", ";transition-property:fill,transform;height:", "px;width:", "px;fill:", ";opacity:", ";", " animation:", ""], _transitions.switchTransition, function (_ref) {
  var size = _ref.size;
  return sizes[size];
}, function (_ref2) {
  var size = _ref2.size;
  return sizes[size];
}, function (_ref3) {
  var theme = _ref3.theme,
      fill = _ref3.fill;
  return (0, _theme.getThemeColor)(theme, fill);
}, function (_ref4) {
  var striked = _ref4.striked;
  return striked ? 0.6 : 1;
}, function (_ref5) {
  var rotate = _ref5.rotate;

  if (rotate) {
    return "\n        transform: rotate(180deg);\n      ";
  }
}, function (_ref6) {
  var name = _ref6.name;
  return name === 'spinner' ? (0, _styledComponents.css)(["", " 3s infinite ease-in-out;"], preloader) : '';
});

var IconWrapper = _styledComponents["default"].span.withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "sc-1rdsvm6-1"
})(["display:inline-flex;", " ", ""], function (_ref7) {
  var paid = _ref7.paid;
  return paid && "\n    position: relative;\n  ";
}, function (_ref8) {
  var striked = _ref8.striked,
      theme = _ref8.theme;

  if (striked) {
    return "\n        position: relative;\n\n        &:after {\n          content: '';\n          position: absolute;\n          border-left: 2px solid ".concat(theme.color.secondaryDarkest, ";\n          width: 2px;\n          border-radius: 50px;\n          height: 150%;\n          transform: rotate(-45deg);\n          top: -25%;\n          left: 50%;\n        }\n      ");
  }
});

exports.IconWrapper = IconWrapper;

var PaidIcon = _styledComponents["default"].span.withConfig({
  displayName: "Icon__PaidIcon",
  componentId: "sc-1rdsvm6-2"
})(["position:absolute;top:-4px;right:-4px;width:12px;height:12px;background-image:url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDEyQTYgNiAwIDEwNiAwYTYgNiAwIDAwMCAxMnoiIGZpbGw9IiNGQTNBMDAiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuMjU1IDMuMDE1bDEuMTYuMDAzYzEuMjc3LjAyMiAxLjU0NS44ODIgMS41NDUgMS42IDAgLjcxOS0uMjY4IDEuNTgtMS41MzMgMS42MDFsLTEuMTcyLjAwNFYzLjAxNXpNNi40MjggNy4wNWMxLjU2Ni0uMDI4IDIuMy0xLjEwMyAyLjMtMi40MzIgMC0xLjMyOC0uNzM0LTIuNDAzLTIuMy0yLjQzbC0xLjk0LS4wMDZ2NC4wNDJIMy4yNzJ2LjgzaDEuMjE0di45ODFIMy4yNzN2LjgzaDEuMjE0di45NTNoLjc2OHYtLjk1MmgyLjU3NHYtLjgzSDUuMjU1di0uOTgybDEuMTczLS4wMDR6IiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo=');"]); // Scoped inside `colorKeys` because `fill` are valid HTML attrs


var Icon = function Icon(_ref9) {
  var prefix = _ref9.prefix,
      name = _ref9.name,
      striked = _ref9.striked,
      className = _ref9.className,
      inheritColor = _ref9.inheritColor,
      rotate = _ref9.rotate,
      paid = _ref9.paid,
      props = (0, _objectWithoutProperties2["default"])(_ref9, ["prefix", "name", "striked", "className", "inheritColor", "rotate", "paid"]);
  return _react["default"].createElement(IconWrapper, {
    striked: striked,
    paid: paid
  }, _react["default"].createElement(IconSvg, (0, _extends2["default"])({}, props, {
    name: name,
    rotate: rotate ? 'true' : '',
    striked: striked,
    className: (0, _classnames["default"])(className, {
      'icon-inherit-color': inheritColor
    })
  }), _react["default"].createElement("use", {
    xlinkHref: "#".concat(prefix, "_").concat(name)
  })), !striked && paid && _react["default"].createElement(PaidIcon, null));
};

Icon.defaultProps = {
  prefix: 'kb',
  size: 'normal',
  fill: null,
  className: null,
  inheritColor: false,
  striked: false,
  rotate: false,
  paid: false
};
Icon.propTypes = {
  name: _propTypes["default"].string.isRequired,
  size: _propTypes["default"].oneOf(Object.keys(sizes)),
  prefix: _propTypes["default"].string,
  fill: _theme.ThemingPropTypes.themeColor,
  className: _propTypes["default"].string,
  inheritColor: _propTypes["default"].bool,
  striked: _propTypes["default"].bool,
  paid: _propTypes["default"].bool,
  rotate: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string])
};

var _default = (0, _styledComponents.withTheme)(Icon);

exports["default"] = _default;